<script setup>
/**
 * TELA DE ESTADO (08/10/2026) — página inteira para quando não há painel a
 * mostrar: conta suspensa, usuário sem escritório. Eram um `EmptyState` cru
 * num fundo cinza, sem marca e sem saída. Agora: o logo do advup, um cartão
 * com a peça de vazio do produto (`.advup-vazio`) e as ações embaixo.
 */
defineProps({
  icone: { type: String, required: true },
  titulo: { type: String, required: true },
  dica: { type: String, default: '' },
  // 'neutro' | 'ambar' | 'rubi'
  tom: { type: String, default: 'neutro' },
});

// Por variável: `src` estático vira import no vite, e a pasta `public` não é
// módulo — a tela inteira deixava de compilar.
const LOGO_CLARO = '/brand-assets/logo-advup.webp';
const LOGO_ESCURO = '/brand-assets/logo-advup-white.webp';
</script>

<template>
  <main class="tela-estado">
    <img class="tela-estado__logo dark:hidden" :src="LOGO_CLARO" alt="advup" />
    <img
      class="tela-estado__logo hidden dark:block"
      :src="LOGO_ESCURO"
      alt="advup"
    />
    <section class="tela-estado__cartao">
      <div class="advup-vazio" :class="`tela-estado--${tom}`">
        <span class="advup-vazio__icone" aria-hidden="true">
          <i :class="icone" />
        </span>
        <p class="advup-vazio__tit">{{ titulo }}</p>
        <p v-if="dica" class="advup-vazio__dica">{{ dica }}</p>
        <div v-if="$slots.default" class="advup-vazio__acao tela-estado__acoes">
          <slot />
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped>
.tela-estado {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  min-height: 100%;
  padding: 32px 16px;
  background: rgb(var(--slate-2));
}

.tela-estado__logo {
  width: auto;
  height: 44px;
}

.tela-estado__cartao {
  width: 100%;
  max-width: 28rem;
  padding: 8px 16px;
  border-radius: 16px;
  background: rgb(var(--solid-1));
  box-shadow:
    0 0 0 1px rgb(var(--slate-4)),
    0 12px 32px -16px rgb(15 23 42 / 0.25);
  animation: tela-estado-chega 0.3s cubic-bezier(0.34, 1.12, 0.44, 1) backwards;
}

.tela-estado__acoes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.tela-estado--ambar {
  --vazio-fundo: rgb(var(--amber-3));
  --vazio-tom: rgb(var(--amber-11));
}

.tela-estado--rubi {
  --vazio-fundo: rgb(var(--ruby-3));
  --vazio-tom: rgb(var(--ruby-11));
}

@keyframes tela-estado-chega {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
}

@media (prefers-reduced-motion: reduce) {
  .tela-estado__cartao {
    animation: none;
  }
}
</style>
